import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { debounceTime, distinctUntilChanged, map, take, tap } from "rxjs";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { NodeService } from "src/app/core/services/node.service";
import { SessionService } from "src/app/core/services/session.service";
import { ErrorCodes } from "../../../../core/models/globals";
import { ApplicationService } from "src/app/core/services/application.service";
import {
  ApplicationVersion,
  SessionApplicationVersion,
} from "src/app/core/models/application";
import { DeploymentService } from "src/app/core/services/deployment.service";

@Component({
  selector: "app-dynamic-workstation",
  templateUrl: "./dynamic-workstation.component.html",
  styleUrls: ["./dynamic-workstation.component.scss"],
})
export class DynamicWorkstationComponent implements OnInit {
  constructor(
    public dialog: MatDialogRef<DynamicWorkstationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      deploymentNames: string[];
      gpuNames: string[];
      availableRam: string[];
      availableCores: string[];
      perSessionMaxTime: string;
    },
    public _sessionService: SessionService,
    public _snackBar: MatSnackBar,
    private _spinner: NgxSpinnerService,
    private _authenticationService: AuthenticationService,
    public nodeService: NodeService,
    private router: Router,
    private applicationService: ApplicationService,
    private depService: DeploymentService
  ) {}
  showSelectDuration: boolean =
    this.data.perSessionMaxTime != null ? false : true;
  timeDuration: string[] = ["1", "2", "4", "6", "8", "10"];
  timePeriod: string;
  depName: string[] = this.data.deploymentNames.filter((name) => name != null);
  gpuNames: string[] = this.data.gpuNames.filter((name) => name != null);
  availableRam: string[] = this.data.availableRam.filter(
    (name) => name != null
  );
  nodeGroupsOfDeployment: string[];
  cores: string[] = this.data.availableCores.filter((name) => name != null);
  platform = ["WINDOWS", "LINUX"];
  currentUser: string = this._authenticationService.currentUserValue.username;
  dynamicWsForm: UntypedFormGroup = new UntypedFormGroup({
    deploymentName: new UntypedFormControl(this.depName[0]),
    nodeGroup: new UntypedFormControl("Default"),
    applicationName: new UntypedFormControl("-1"),
    applicationVersion: new UntypedFormControl("-1"),
    cpuCores: new UntypedFormControl("-1"),
    gpuName: new UntypedFormControl("-1"),
    ram: new UntypedFormControl("-1"),
    platform: new UntypedFormControl("-1"),
    duration: new UntypedFormControl("-1"),
  });
  useVncFile: boolean = false;
  applicationNames: string[] = [];
  sessionAppsVersion: SessionApplicationVersion[] = [];
  appVersionList = [];

  ngOnInit(): void {
    if (!this.depName || this.depName == null || this.depName.length == 0) {
      this._snackBar.open("No deployment selected or attached.", "OK", {
        duration: 5000,
      });
      this._spinner.hide("connectWs");
      this.dialog.close();
      return;
    }
    this.dynamicWsForm
      .get("deploymentName")
      .valueChanges.pipe(debounceTime(200), distinctUntilChanged())
      .subscribe((value) => {
        this._spinner.show("connectWs");
        this.getApplicationNames();
        this.getNodeGroupsForDeployments();
      });
    //this.dynamicWsForm.get("deploymentName").valueChanges.subscribe((value) => {
    //  this._spinner.show("connectWs");
    //  this.getApplicationNames();
    //});
    this.dynamicWsForm
      .get("applicationName")
      .valueChanges.subscribe((value) => {
        if (value != "-1") {
          this.dynamicWsForm.get("cpuCores").setValue("-1");
          this.dynamicWsForm.get("gpuName").setValue("-1");
          this.dynamicWsForm.get("ram").setValue("-1");
          this.dynamicWsForm.get("platform").setValue("-1");
          this.dynamicWsForm.get("duration").setValue("-1");
          this.dynamicWsForm.get("applicationVersion").setValue("-1");
          // disable above fields
          this.dynamicWsForm.get("cpuCores").disable();
          this.dynamicWsForm.get("gpuName").disable();
          this.dynamicWsForm.get("ram").disable();
          this.dynamicWsForm.get("platform").disable();
          this.dynamicWsForm.get("duration").disable();
          this.dynamicWsForm.get("applicationVersion").enable();
        } else {
          // update values
          this.dynamicWsForm.get("applicationVersion").setValue("-1");
          this.dynamicWsForm.get("applicationVersion").disable();
          this.dynamicWsForm.get("cpuCores").enable();
          this.dynamicWsForm.get("gpuName").enable();
          this.dynamicWsForm.get("ram").enable();
          this.dynamicWsForm.get("platform").enable();
          this.dynamicWsForm.get("duration").enable();
        }
        this.dynamicWsForm.updateValueAndValidity();
      });
    this.getApplicationNames();
    this.getNodeGroupsForDeployments();
  }

  onCancel() {
    this.dialog.close(false);
  }

  async onSubmit() {
    if (!this.dynamicWsForm.value.deploymentName) {
      this._snackBar.open("No deployment selected or attached.", "OK", {
        duration: 5000,
      });
      this._spinner.hide("connectWs");
      this.dialog.close();
      return;
    }
    if (
      this.dynamicWsForm.value.applicationName != "-1" &&
      this.dynamicWsForm.value.applicationVersion == "-1"
    ) {
      this._snackBar.open("Please select application version", "OK", {
        duration: 5000,
      });
      return;
    }
    this._spinner.show("connectWs");
    if (this.data.perSessionMaxTime != null) {
      this.timePeriod = this.data.perSessionMaxTime;
    } else {
      this.timePeriod =
        this.dynamicWsForm.value.duration == "-1"
          ? ""
          : this.dynamicWsForm.value.duration;
    }
    await this.getVncFileTag(this.dynamicWsForm.value.deploymentName);
    this._sessionService
      .requestSessionFromDeployment(
        this.dynamicWsForm.value.deploymentName,
        this.dynamicWsForm.getRawValue(),
        this.dynamicWsForm.value.nodeGroup,
        this.currentUser,
        this.timePeriod
      )
      .pipe(take(1))
      .subscribe((data: any) => {
        if (data) {
          let response = JSON.parse(data["message"]);

          if (
            data.actionCode != ErrorCodes.Succeeded &&
            data.actionCode != ErrorCodes.In_Transition
          ) {
            this._snackBar.open(response.FileContent, "Ok", { duration: 5000 });
            this.dialog.close(true);
            this._spinner.hide("connectWs");
            return;
          }

          if (response.VmPlatform.toLowerCase() == "windows") {
            //this.download(response.VmName + ".rdp", response.FileContent);
          } else if (
            response.VmPlatform.toLowerCase() == "linux" &&
            this.useVncFile
          ) {
            //this.download(response.VmName + ".vnc", response.FileContent);
          } else if (
            !response.VmName ||
            response.VmName == "" ||
            response.VmPlatform == ""
          ) {
            this._snackBar.open(response.FileContent, "Ok", { duration: 5000 });
            this.dialog.close(true);
            this._spinner.hide("connectWs");
            return;
          } else {
            let url = response.FileContent;
            //window.open(url, '_blank');
          }
        } else {
          this._snackBar.open("Something went wrong!", "Ok", {
            duration: 5000,
          });
        }
        this.dialog.close(true);
        this.refreshComponent();
        this._spinner.hide("connectWs");
      });
  }

  download(filename, fileData) {
    filename = filename.replace(/['"]+/g, "");
    const blob = new Blob([fileData], { type: "text/csv" });
    let url = window.URL.createObjectURL(blob);
    let elementAnchor = document.createElement("a");
    document.body.appendChild(elementAnchor);
    elementAnchor.setAttribute("style", "display: none");
    elementAnchor.href = url;
    elementAnchor.download = filename;
    elementAnchor.click();
    window.URL.revokeObjectURL(url);
    elementAnchor.remove();
  }

  getVncFileTag(depName: string) {
    this.nodeService.getUseVncFileTagValue(depName).subscribe({
      next: (data: any) => {
        this.useVncFile = data.isUseVncFile;
        return;
      },
    });
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  getApplicationNames() {
    let depName = this.dynamicWsForm.value.deploymentName;
    this.applicationService.getApplicationNameVersForUser(depName).subscribe({
      next: (data: SessionApplicationVersion[]) => {
        this.sessionAppsVersion = [...data];

        this.applicationNames = data.map((app) => app.applicationName);
        // this.dynamicWsForm.get("applicationName").setValue(this.applicationNames[0]);
        this._spinner.hide("connectWs");
        return;
      },
      error: (error: any) => {
        // this._snackBar.open(error.error.message, "Ok", { duration: 5000 });
        this._spinner.hide("connectWs");
        return;
      },
    });
  }

  getApplicationVersion() {
    let appName = this.dynamicWsForm.value.applicationName;
    if (appName != "-1") {
      let applicationVersionDetail = this.sessionAppsVersion.find(
        (e) => e.applicationName == appName
      );
      this.appVersionList = [...applicationVersionDetail.appVersionDetails];
    }
  }

  getNodeGroupsForDeployments() {
    let depName = this.dynamicWsForm.value.deploymentName;
    this.depService.getNodeGroupsForDeployment(depName).subscribe({
      next: (data) => {
        this.nodeGroupsOfDeployment = JSON.parse(JSON.stringify(data));
        this.nodeGroupsOfDeployment = Array.from(
          new Map(this.nodeGroupsOfDeployment.map(x => [x.toLowerCase(), x])).values()
        );

        if (this.nodeGroupsOfDeployment.length > 0) {
          this.dynamicWsForm.get('nodeGroup').setValue(this.nodeGroupsOfDeployment[0]);
        }

      },
      error: (err) => {
        console.error(err);
      },
    });
  }
}
